import React, { Component } from 'react'
import AOS from 'aos';
import FormField from "../../components/Form"
import Button from "../../components/Button"
import currencyIcon from "../../assets/images/currencyIcon.svg"

class NewsLetter extends Component {
    componentDidMount() {
        // or simply just AOS.init();
        AOS.init({
          // initialise with other settings
          duration : 1000
        });
      }
    render() {
        return (
            <>
                <div className="newsletter">
                    <div data-aos="fade-up" data-aos-delay="80" data-aos-duration="1300">
                        <img src={currencyIcon} alt="currency image" />
                    </div>
                    <div className="access-market">
                        <p className="tik-border"></p>
                        <div data-aos="fade-right" data-aos-delay="100" data-aos-duration="1500">
                            <h1 className="main-color">ACCESS TO THE GLOBAL FINANCIAL MARKETS WITH US!</h1>
                            <h5 className="mt-10">Get the best trading portfolio and results as we guide you through the FOREX and CRYPTOCURRENCY and STOCKS Market.</h5>
                        </div>
                    </div>
                </div>
                <div className="newsletter-body">
                    <h4 className="text-white bold">SUBSCRIBE TO OUR NEWSLETTER & UPDATES</h4>
                    <div className="subscribe-form">
                        <FormField
                            placeholder="Enter your email address here"
                            classNam="newsletter-email br-5"
                        />
                        <Button className="br-5 newsletter-button">Subscribe</Button>
                    </div>
                </div>
            </>
        )
    }
}

export default NewsLetter;